'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _plus = require('../../styles/images/plus.svg');

var _plus2 = _interopRequireDefault(_plus);

var _PlusIconStyled = require('./PlusIconStyled');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var PlusIcon = function PlusIcon(_ref) {
  var props = _objectWithoutProperties(_ref, []);

  return _react2.default.createElement(_PlusIconStyled.IconStyled, _extends({ src: _plus2.default }, props));
};

exports.default = PlusIcon;
module.exports = exports['default'];